import { FormattedDate } from 'react-intl';

export const Document = ({ document }) => (
    <div
        className="flex justify-between px-l py-s font-reg"
        data-testid="document"
    >
        <span>{document.attributes.document_name}</span>
        <span>
            <FormattedDate
                value={new Date(document.attributes.uploaded_at)}
                day="2-digit"
                month="short"
                year="numeric"
            />
        </span>
    </div>
);
